/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class CreateApprovedSenderForTransitsRequest {
  public permissionNumber: string = undefined;
  public customerCompanyId: string = undefined;
  public goodsLocalCode: string = undefined;
  public warehouseOwner: string = undefined;
  public address: string = undefined;
  public postCode: string = undefined;
  public city: string = undefined;
  public departureCustomsOfficeId: string = undefined;
  public appliedUtc: Date | string;
  public approvedUtc: Date | string;
}
